{
  "switchOffice": "Lumipat ng opisina",
  "noOfficeTitle": "Wala ka pa sa isang opisina",
  "noOfficeBody": "Hilingin sa pinuno ng iyong opisina o sa administrator ng LGU na idagdag ka.",
  "navDashboard": "Dashboard",
  "navPosts": "Mga post at event",
  "navCheckin": "Check-in",
  "navDispatch": "Dispatch",
  "navCrop": "Pinsala sa pananim",
  "navSafety": "Mapa ng kaligtasan",
  "navEmergencyMode": "Emergency mode",
  "navProfile": "Profile ng opisina",
  "navTeam": "Mga kawani",
  "navAdminHome": "Pangkalahatang-tanaw",
  "navOffices": "Mga opisina",
  "navStaffAccounts": "Mga account ng kawani",
  "navSettings": "Mga setting ng LGU",
  "navHotlines": "Mga hotline",
  "navResponders": "Mga responder team",
  "navDisasterEvents": "Mga sakuna",
  "navCategories": "Mga kategorya",
  "navAudit": "Audit log",
  "navSmsLog": "SMS log",
  "role_viewer": "Viewer",
  "role_contributor": "Contributor",
  "role_editor": "Editor",
  "role_office_head": "Pinuno ng opisina",
  "readOnly": "Pagtingin lang ang access mo sa opisinang ito.",
  "newPost": "Bagong post",
  "type_announcement": "Anunsyo",
  "type_schedule": "Iskedyul",
  "type_program": "Programa",
  "urgent": "Agaran",
  "pinned": "Naka-pin",
  "status_draft": "Draft",
  "status_pending_approval": "Naghihintay ng pag-apruba",
  "status_published": "Nakalathala",
  "status_archived": "Naka-archive",
  "status_scheduled": "Nakaiskedyul",
  "status_cancelled": "Kanselado",
  "filter_pending_approval": "Naghihintay ng pag-apruba",
  "filter_draft": "Mga draft",
  "filter_published": "Nakalathala",
  "filter_scheduled": "Nakaiskedyul",
  "filter_archived": "Naka-archive",
  "statPublished": "Nakalathalang post",
  "statScheduled": "{count} nakaiskedyul na ilathala",
  "statViews": "Mga view ng post",
  "statRegistrations": "Mga rehistro",
  "statAttendance": "Dumalo",
  "last30": "Huling 30 araw",
  "attendanceOf": "{attended} sa {expected} ang nag-check in (huling 90 araw)",
  "attendanceNone": "Wala pang natapos na event na may rehistro",
  "pendingApprovals": "Naghihintay ng pag-apruba",
  "noPendingApprovals": "Walang naghihintay ng pag-apruba.",
  "submittedBy": "Mula kay {name} · {date}",
  "review": "Suriin",
  "needsReview": "Mga rehistrong susuriin",
  "noNeedsReview": "Walang rehistrong naghihintay ng iyong desisyon.",
  "pendingCount": "{count} naghihintay",
  "confirmedCount": "{count} kumpirmado",
  "waitlistCount": "{count} nasa waitlist",
  "upcoming": "Mga paparating na event",
  "allPosts": "Lahat ng post",
  "noUpcoming": "Walang paparating na event",
  "noUpcomingBody": "Mag-post ng iskedyul o programa para malaman ng mga residente ang paparating.",
  "noRegistration": "Walang rehistro para sa event na ito.",
  "registered": "Nakarehistro",
  "registrants": "Mga nagparehistro",
  "seatsOf": "{taken} sa {capacity}",
  "seatsNoLimit": "{taken} nakarehistro · walang limit",
  "capacity": "Kapasidad",
  "postsLead": "Mga anunsyo, iskedyul at programa ng iyong opisina.",
  "searchPosts": "Maghanap ng pamagat",
  "noPosts": "Wala pang post",
  "noPostsBody": "Dito lalabas ang mga anunsyo, iskedyul at programa ng iyong opisina.",
  "noPostsMatch": "Walang tugmang post",
  "publishesOn": "Ilalathala sa {date}",
  "updatedBy": "{name}, {date}",
  "registeredShort": "nakarehistro",
  "viewsShort": "view",
  "viewPublic": "Tingnan gaya ng nakikita ng residente",
  "reviewTitle": "Suriin ang post na ito",
  "reviewLead": "Ilathala na ngayon, o ibalik sa sumulat na may tala kung ano ang babaguhin.",
  "reviewNote": "Tala para sa sumulat",
  "reviewNoteHint": "Kailangan kapag ibinabalik ang post.",
  "returnNoteRequired": "Sabihin sa sumulat kung ano ang babaguhin.",
  "approvePublish": "Aprubahan at ilathala",
  "returnToDraft": "Ibalik na may tala",
  "openEditor": "Buksan sa editor",
  "approved": "Naaprubahan at nailathala.",
  "returned": "Naibalik sa sumulat.",
  "checkinLead": "I-scan ang QR ticket ng residente, o hanapin ayon sa pangalan o mobile number.",
  "checkinEvent": "Event",
  "checkinAnyEvent": "Alinman sa aming mga event",
  "checkinEventHint": "Tatanggihan ang mga ticket para sa ibang event.",
  "checkinAnyHint": "Piliin ang event sa pintong ito para mahuli ang mga ticket ng ibang event.",
  "checkinMode": "Paraan ng check-in",
  "checkinEditorsOnly": "Mga editor at pinuno ng opisina lang ang puwedeng mag-check in ng tao.",
  "checkinOffline": "Walang koneksyon. Tingnan ang pangalan sa ticket at subukang muli kapag online na.",
  "arrived": "Naka-check in",
  "scanQr": "I-scan ang QR",
  "searchName": "Hanapin ang pangalan",
  "startCamera": "Buksan ang camera",
  "stopCamera": "Isara ang camera",
  "cameraView": "View ng camera para sa pag-scan ng ticket",
  "cameraDenied": "Naka-block ang camera. Payagan ito sa settings ng browser, o i-type ang ticket code sa ibaba.",
  "cameraError": "Hindi nabuksan ang camera. I-type ang ticket code sa ibaba o maghanap ayon sa pangalan.",
  "ticketCode": "Ticket code",
  "ticketCodePlaceholder": "O i-type ang code",
  "ticketNotFound": "Walang ticket na may ganitong code para sa opisinang ito.",
  "searchPlaceholder": "Pangalan, mobile number o ticket code",
  "searchNoMatch": "Walang nahanap. Suriin ang spelling o subukan ang mobile number.",
  "otherEvent": "Ibang event",
  "outcomeOk": "Naka-check in na",
  "outcomeAlready": "Naka-check in na kanina",
  "outcomeWrongEvent": "Maling event",
  "outcomeNotConfirmed": "Hindi kumpirmado",
  "outcomeNotFound": "Walang ganitong ticket",
  "alreadyAt": "Nag-check in noong {time}.",
  "nextPerson": "Susunod na tao",
  "profileLead": "Ang nakikita ng mga residente sa pahina ng iyong opisina.",
  "viewPublicProfile": "Tingnan ang pampublikong pahina",
  "headOnly": "Ang pinuno ng opisina lang ang puwedeng magbago nito.",
  "officeType_municipal": "Opisina ng munisipyo",
  "officeType_barangay": "Barangay",
  "nameByAdmin": "Ang administrator ng LGU ang namamahala sa mga pangalan ng opisina.",
  "uploadLogo": "Mag-upload ng logo",
  "replaceLogo": "Palitan ang logo",
  "removeLogo": "Alisin ang logo",
  "icon": "Icon (lalabas kapag walang logo)",
  "description": "Tungkol sa opisinang ito",
  "descriptionHint": "Ano ang ginagawa ng opisina at anong serbisyo ang makukuha rito ng mga residente.",
  "location": "Lokasyon",
  "locationHint": "hal. 2nd floor, Munisipyo",
  "officeHours": "Oras ng opisina",
  "officeHoursHint": "hal. Lunes hanggang Biyernes, 8:00 AM – 5:00 PM",
  "contact": "Paano makipag-ugnayan",
  "contactPhone": "Telepono",
  "contactOther": "Iba pang contact",
  "contactOtherHint": "hal. Facebook page o pangalawang numero",
  "mapLocation": "Lokasyon sa mapa",
  "mapLocationHint": "Opsyonal. Tumutulong sa mga residente na mahanap ang opisina.",
  "profileSaved": "Na-save ang profile ng opisina.",
  "lastUpdated": "Huling na-update {date}",
  "teamLead": "Mga taong puwedeng magtrabaho para sa {office} sa app na ito.",
  "inviteTitle": "Mag-imbita ng kawani",
  "inviteLead": "Gamitin ang opisyal na email ng tao sa opisina. Makakatanggap sila ng link para gumawa ng password. Hindi nagsa-sign up nang mag-isa ang mga kawani.",
  "inviteEmail": "Email address",
  "role": "Tungkulin",
  "sendInvite": "Ipadala ang imbitasyon",
  "inviteSent": "Naipadala ang imbitasyon kay {email}.",
  "inviteCreated": "Nagawa ang imbitasyon. Hindi pa naka-set up ang email, kaya ibahagi ang link sa ibaba.",
  "memberAdded": "Naidagdag si {email} sa opisinang ito.",
  "memberUpdated": "Na-update ang tungkulin ni {email}.",
  "inviteLinkTitle": "Ipadala ang link na ito sa tao",
  "inviteLinkBody": "Hindi pa naka-set up ang email, kaya hindi na-email ang imbitasyon. Ipadala nang pribado ang link na ito (gagana ito nang 7 araw).",
  "copyLink": "Kopyahin ang link",
  "noStaff": "Wala pang kawani",
  "teamList": "Mga kawani ({count})",
  "you": "ikaw",
  "statusInvited": "Inimbitahan",
  "statusDeactivated": "Naka-deactivate",
  "lastSignIn": "Huling nag-sign in {date}",
  "neverSignedIn": "Hindi pa nagsa-sign in",
  "roleFor": "Tungkulin ni {name}",
  "roleChanged": "{role} na si {name}.",
  "removeFromOffice": "Alisin si {name} sa opisinang ito",
  "confirmRemove": "Alisin si {name} sa {office}? Mawawala agad ang access niya sa opisinang ito.",
  "removed": "Naalis si {name} sa opisinang ito.",
  "deactivateNote": "May aalis sa LGU? Puwedeng i-deactivate ng administrator ang buong account niya.",
  "rolesExplained": "Ano ang magagawa ng bawat tungkulin",
  "roleHelp_office_head": "Namamahala sa mga kawani at profile ng opisina, at lahat ng magagawa ng editor.",
  "roleHelp_editor": "Naglalathala ng post, nag-aapruba ng draft ng contributor, namamahala sa rehistro at check-in.",
  "roleHelp_contributor": "Sumusulat ng draft at ipinapadala para sa pag-apruba.",
  "roleHelp_viewer": "Nakikita ang mga post at rehistro, pero walang mababago.",
  "navRequests": "Mga request",
  "navServices": "Serbisyo at charter",
  "navAlerts": "Agarang abiso",
  "navFeedback": "Puna",
  "navReportCategories": "Uri ng problema",
  "navHolidays": "Mga holiday",
  "navRevenue": "Revenue desk",
  "navGuides": "Mga gabay sa bayan",
  "navMarketPrices": "Presyo sa palengke",
  "navRecycling": "Pagkuha ng recyclables",
  "navFacilities": "Mga pasilidad",
  "navModeration": "Pag-moderate ng komunidad",
  "navTourism": "Turismo",
  "navTransparency": "Transparency",
  "navOrdinances": "Mga ordinansa",
  "navTownGuides": "Mga gabay sa bayan",
  "navHq": "Headquarters",
  "openHq": "Buksan ang headquarters"
}
